var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',_vm._b({ref:"videoRef",attrs:{"controls":""},on:{"click":function($event){$event.stopPropagation();return _vm.handle.apply(null, arguments)}}},'video',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }